// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Bj4","colBig":"styles_colBig__OyB_U","colSmall":"styles_colSmall__vIbzX"};